import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Accordion, AccordionGroup } from '../../../components_common/Accordion';
import BrandsFilter from '../../../components_common/Filters/BrandsFilter';
import CategoryFilter from '../../../components_common/Filters/CategoryFilter';
import SeasonsFilter from '../../../components_common/Filters/SeasonsFilter';
import SizesFilter from '../../../components_common/Filters/SizesFilter';
import RefineBySection from '../../../components_common/RefineBySection';
import DividerLine from '../../../components_common/DividerLine';
import SizeGuide from '../SizeGuide';
import TotalResultsBanner from '../TotalResultsBanner';
import { clearFilters, filterBrands, filterCategories, filterSeasons, filterSizes } from '../../../common/actions';
import { filterModalStyle, FiltersWrapper } from './FiltersModal.css';
import FilterModalHeader from './FilterModalHeader';
import { FilterTypes, SeasonData } from '../../../common/models';
import { allModes, designerMode } from '../../../helpers/productListModes';
import { fdStyleChange } from '../../../helpers/fdHelper';
import { isShoesCategory, isWomenCategory } from '../../../helpers/search_helpers';
import { SizeData } from '../../../common/models/SizeData';
import TrackingEvents from '../../../common/models/TrackingEvents';
import { track } from '../../../helpers';

const mapStateToProps = ({ api: { countryId, filterSettings, s3BasePath, categoryUrl }, department }) => ({
  countryId,
  department,
  filterSettings,
  s3BasePath,
  categoryUrl
});

const mapDispatchToProps = dispatch => ({
  handleBrandsFilter: (brandsIds, mode) => dispatch(filterBrands(brandsIds, mode)),
  handleCategoriesFilter: (categoryId, categoryUrl, categoryName, mode) =>
    dispatch(filterCategories(categoryId, categoryUrl, categoryName, mode)),
  handleSeasonsFilter: (currSeasons, mode) => dispatch(filterSeasons(currSeasons, mode)),
  handleSizesFilter: (sizes, mode) => dispatch(filterSizes(sizes, mode)),
  handleClearFilters: (availableFilters, mode) => dispatch(clearFilters(availableFilters, mode))
});

class FiltersModal extends Component {
  constructor(props) {
    super(props);
    this.renderCategoryFilter = this.renderCategoryFilter.bind(this);
    this.renderDesignerFilter = this.renderDesignerFilter.bind(this);
    this.renderSeasonFilter = this.renderSeasonFilter.bind(this);
    this.renderSizeFilter = this.renderSizeFilter.bind(this);
    this.state = {
      changeFd: false,
      filtersOpenIndex: 0
    };
  }

  componentDidMount() {
    this.setState({ changeFd: true });
  }

  renderCategoryFilter() {
    const { filterSettings, handleCategoriesFilter, mode } = this.props;
    const { categoryTree, departmentIdsForBrands, currentCategoryId } = filterSettings;

    return (
      <Accordion title="CATEGORIES">
        <Row>
          <Column fluid>
            <CategoryFilter
              departmentIdsForBrands={departmentIdsForBrands}
              isDesignerMode={mode === designerMode}
              handleFilterClick={(...args) => handleCategoriesFilter(...args, mode)}
              filters={categoryTree}
              currCategoryId={currentCategoryId}
            />
          </Column>
        </Row>
      </Accordion>
    );
  }

  renderDesignerFilter() {
    const { filterSettings, handleBrandsFilter, mode } = this.props;
    const { brandsIds, availableBrands } = filterSettings;

    return (
      <Accordion title="DESIGNERS">
        <Row>
          <Column fluid>
            <BrandsFilter
              handleFilterClick={(...args) => handleBrandsFilter(...args, mode)}
              availableBrands={availableBrands}
              selectedBrandsIds={brandsIds}
            />
          </Column>
        </Row>
      </Accordion>
    );
  }

  renderSeasonFilter() {
    const { filterSettings, handleSeasonsFilter, mode } = this.props;
    const { availableSeasons, currentSeason, seasons } = filterSettings;

    return (
      <Accordion title="SEASONS">
        <Row>
          <Column fluid>
            <SeasonsFilter
              availableSeasons={availableSeasons.map(el => SeasonData.fromSeasonString(el))}
              currentSeason={SeasonData.fromSeasonString(currentSeason)}
              handleFilterClick={(...args) => handleSeasonsFilter(...args, mode)}
              isDesktop={false}
              selectedSeasons={seasons.map(el => SeasonData.fromSeasonString(el))}
            />
          </Column>
        </Row>
      </Accordion>
    );
  }

  renderSizeFilter() {
    const { countryId, department, filterSettings, handleSizesFilter, s3BasePath, mode } = this.props;
    const { availableSizes, categoryTree, currentCategoryId, sizes } = filterSettings;

    return (
      <Accordion title="SIZES">
        <Row>
          <Column fluid>
            <SizesFilter
              department={department}
              countryId={countryId}
              handleFilterClick={(...args) => handleSizesFilter(...args, mode)}
              sizes={SizeData.sizesArrayWithUniversalToString(
                availableSizes,
                isShoesCategory(currentCategoryId),
                department
              )}
              currSizes={SizeData.sizesArrayToString(sizes, department)}
              isShoesCategory={isShoesCategory(currentCategoryId)}
              s3BasePath={s3BasePath}
            />
            <SizeGuide
              categoryTree={categoryTree}
              currentCategoryId={currentCategoryId}
              filtersModal
              department={department}
              s3BasePath={s3BasePath}
            />
          </Column>
        </Row>
      </Accordion>
    );
  }

  getFilterType = index => {
    switch (index) {
      case 0:
        return 'category';
      case 1:
        return 'brand';
      case 2:
        return 'seasons';
      case 3:
        return 'sizes';
      default:
        return null;
    }
  };

  trackFilterToggled = index => {
    const { filtersOpenIndex } = this.state;
    if (filtersOpenIndex !== -1) {
      track(TrackingEvents.filterClose(), { ui: { 'filter type': this.getFilterType(filtersOpenIndex) } });
    }
    if (index !== -1 && index !== filtersOpenIndex) {
      track(TrackingEvents.filterOpen(), { ui: { 'filter type': this.getFilterType(index) } });
    }
  };

  handleFiltersExpand = index => {
    const { filtersOpenIndex } = this.state;
    this.trackFilterToggled(index);
    if (filtersOpenIndex === index) {
      this.setState({ filtersOpenIndex: -1 });
    } else {
      this.setState({ filtersOpenIndex: index });
    }
  };

  render() {
    const {
      availableFilters,
      department,
      isOpen,
      s3BasePath,
      toggle,
      filterSettings,
      handleBrandsFilter,
      handleClearFilters,
      handleSeasonsFilter,
      handleSizesFilter,
      mode
    } = this.props;

    const { categoryTree, currentCategoryId } = filterSettings;
    const { changeFd, filtersOpenIndex } = this.state;

    if (changeFd) {
      fdStyleChange('visibility', isOpen ? 'hidden' : 'visible', null);
    }

    return (
      <Modal isOpen={isOpen} style={filterModalStyle}>
        <FiltersWrapper>
          <FilterModalHeader s3BasePath={s3BasePath} toggle={toggle} />
          <DividerLine size={5} />
          <RefineBySection
            department={department}
            availableFilters={availableFilters}
            s3BasePath={s3BasePath}
            filterSettings={filterSettings}
            isDesktop={false}
            isWomenCategory={isWomenCategory(categoryTree, currentCategoryId)}
            handleClearFilters={(...args) => {
              this.setState({ filtersOpenIndex: 0 });
              handleClearFilters(...args, mode);
            }}
            handleSizesFilter={(...args) => handleSizesFilter(...args, mode)}
            handleSeasonsFilter={(...args) => handleSeasonsFilter(...args, mode)}
            handleBrandsFilter={(...args) => handleBrandsFilter(...args, mode)}
          />
          <DividerLine size={0.5} />
          <AccordionGroup
            iconPosition="right"
            s3BasePath={s3BasePath}
            dividerComp={<DividerLine size={0.5} />}
            handleTriggerClick={this.handleFiltersExpand}
            openPosition={filtersOpenIndex}
          >
            {availableFilters.includes(FilterTypes.category()) && this.renderCategoryFilter()}
            {availableFilters.includes(FilterTypes.designer()) && this.renderDesignerFilter()}
            {availableFilters.includes(FilterTypes.season()) && this.renderSeasonFilter()}
            {availableFilters.includes(FilterTypes.size()) && this.renderSizeFilter()}
          </AccordionGroup>
        </FiltersWrapper>
        <TotalResultsBanner onClick={toggle} />
      </Modal>
    );
  }
}

FiltersModal.propTypes = {
  department: PropTypes.string,
  countryId: PropTypes.string.isRequired,
  availableFilters: PropTypes.arrayOf(PropTypes.oneOf([FilterTypes.season(), FilterTypes.size(), FilterTypes.designer(), FilterTypes.category()])).isRequired,
  filterSettings: PropTypes.object,
  handleBrandsFilter: PropTypes.func,
  handleCategoriesFilter: PropTypes.func,
  handleClearFilters: PropTypes.func,
  handleSeasonsFilter: PropTypes.func,
  handleSizesFilter: PropTypes.func,
  isOpen: PropTypes.bool,
  isShoesCategory: PropTypes.bool,
  s3BasePath: PropTypes.string.isRequired,
  toggle: PropTypes.func,
  mode: PropTypes.oneOf(allModes).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltersModal);
